var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17012_59082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.16797C4.28 1.16797 1.66666 3.7813 1.66666 7.0013C1.66666 10.2213 4.28 12.8346 7.5 12.8346C10.72 12.8346 13.3333 10.2213 13.3333 7.0013C13.3333 3.7813 10.72 1.16797 7.5 1.16797ZM7.5 9.91797C7.17916 9.91797 6.91666 9.65547 6.91666 9.33464V7.0013C6.91666 6.68047 7.17916 6.41797 7.5 6.41797C7.82083 6.41797 8.08333 6.68047 8.08333 7.0013V9.33464C8.08333 9.65547 7.82083 9.91797 7.5 9.91797ZM6.91666 5.2513H8.08333V4.08464H6.91666V5.2513Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17012_59082)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    fill: "#FF0606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRejected);
export default __webpack_public_path__ + "static/media/info-rejected.551c7d7889a478b6172d2d3f75e1c664.svg";
export { ForwardRef as ReactComponent };